import glamorous from 'glamorous';
import { mediaQueries } from '../../constants/mediaqueries.const';

export const LoginButton = glamorous.button('a', {});
LoginButton.displayName = 'LoginButton';

export const ContentWrapper = glamorous.div('ncss-container fixed-fluid', {
  padding: '0 16px',
  ' .confirmation-CTA:hover': {
    color: '#b0b0b0',
  },
  [mediaQueries.tablet]: {},
  [mediaQueries.desktop]: {},
});
ContentWrapper.displayName = 'ContentWrapper';



// WEBPACK FOOTER //
// ./src/containers/ConfirmationPage/ConfirmationPage.style.js